import { 
    ADD_TASK,
    TASK_PROJECT, 
    VALIDATE_TASK,
    DELETE_TASK,
    //TASK_STATUS,
    ACTUAL_TASK,
    UPDATE_TASK,
    CLEAN_TASK
} from "../../types";

export default (state, action) => {
    switch (action.type) {
        case TASK_PROJECT: 
            return {
                ...state,
                //projectTasks: state.projectTasks.filter(task => task.projectID === action.payload)
                projectTasks: action.payload
            }
        case ADD_TASK:
            return {
                ...state,
                projectTasks: [ action.payload, ...state.projectTasks ],
                errorTask: false
            }
        case VALIDATE_TASK:
            return {
                ...state,
                errorTask: true
            }
        case DELETE_TASK:
            return {
                ...state,
                projectTasks: state.projectTasks.filter(task => task._id !== action.payload)
            }
        case UPDATE_TASK:    
        //case TASK_STATUS:
            return {
                ...state,
                projectTasks: state.projectTasks.map(task => task._id === action.payload._id ? action.payload : task)
            }
        case ACTUAL_TASK: 
            return {
                ...state,
                selectedTask: action.payload
            }
        case CLEAN_TASK: 
            return {
                ...state,
                selectedTask: null
            }
        // case UPDATE_TASK: 
        //     return {
        //         ...state,
        //         tasks: state.projectTasks.map(task => task.id === action.payload.id ? action.payload : task)
        //     }
        default:
            return state;
    }
}